import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _, { forEach } from 'lodash';
import {
	Grid,
	Header,
	Image,
	Form,
	Dropdown,
	FormGroup,
} from 'semantic-ui-react';
import 'mapbox-gl/dist/mapbox-gl.css';
import MainMenu from './Menu';
import AgeChart from './AgeChart';
import NaloxonaChart from './NaloxonaChart';
import ResultChart from './ResultChart';
import SubstancesChart from './SubstancesChart';
import PrescribeChart from './PrescribeChart';
import Seal from '../assests/seal.svg';
import Logo from '../assests/logo.png'
import PassedChart from './PassedChart';
import TimelineChart from './TimelineChart';
import Map from './Map';
import { municipalities, regions } from '../utils/Functions';
import { getData } from '../store/actions/Data';
import PlaceChart from './PlaceChart';
import SexChart from './SexChart';
import MonthlyChart from './MonthlyChart';
import SleepChart from './SleepChart';
import DoseChart from './DoseChart';
import { DateInput } from 'semantic-ui-calendar-react';
import { toast } from 'react-toastify';

function Dashboard() {
	const [data, setData] = useState({
		data: null,
		region: '',
		fromdate: '',
		todate: '',
		municipality: [],
		entidad_group: [],
		month: '',
		year: '',
		passed: '',
		opiodes: [],
	});
	const [opiodesValues, setOpiodesValues] = useState([]);
	const events = useSelector((s) => s.data.data);

	const dispatch = useDispatch();
	useEffect(() => {
		if (!events) {
			dispatch(getData());
		}
		if (events) {
			let OpiodesValue = [];
			events.forEach((opiodesElement) => {
				if (opiodesElement.opiodes !== null || undefined) {
					opiodesElement.opiodes.forEach((opiodesVal) => {
						OpiodesValue.push(opiodesVal);
					});
				}
			});
			setOpiodesValues(_.uniq(OpiodesValue));
		}
	}, [events, dispatch]);

	const getDateFormat = (date, compareDate) => {
		if (!date) {
			return new Date(compareDate).toLocaleString().split(',')[0];
		}
		return new Date(date.split('T')[0]).toLocaleString().split(',')[0];
	};

	function compareDates(dateStr1, dateStr2, extra) {
		if (!dateStr1 || !dateStr2) {
			return false;
		}
		const [month1, day1, year1] = dateStr1.split('/');
		const [month2, day2, year2] = dateStr2.split('/');

		const date1 = new Date(
			`${year1}-${month1.padStart(2, '0')}-${day1.padStart(2, '0')}`
		);
		const date2 = new Date(
			`${year2}-${month2.padStart(2, '0')}-${day2.padStart(2, '0')}`
		);

		// if(date2.toString().includes('2024')) {
		// 	console.log('date1',date1)
		// 	console.log('date2',date2)
		// }

		return date1 <= date2;
	}
	const fromDateChangeHandler = (e, { value }) => {
		if (data.todate.trim()) {
			const fromDateValue = new Date(value).getTime();
			const toDateValue = new Date(data.todate).getTime();
			if (fromDateValue > toDateValue) {
				toast('Invalid date', { type: 'error' });
				return;
			}
		}
		setData({ ...data, fromdate: value });
	};
	const toDateChangeHandler = (e, { value }) => {
		const fromDateValue = new Date(data.fromdate).getTime();
		const toDateValue = new Date(value).getTime();

		if (toDateValue < fromDateValue) {
			toast('Invalid date', { type: 'error' });
		} else {
			setData({ ...data, todate: value });
		}
	};
	const getCurrentMonthStartDateFormatted = (newDate) => {
		const currentDate = new Date(newDate);
		const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
		const year = currentDate.getFullYear().toString();
		// Adding 1 because months are zero-based
		return `${month}/01/${year}`;
	};
	useEffect(() => {
		const conditions = Object.create(null);

		if (data.region) {
			conditions.region = data.region;
		}
		if (data.municipality.length) {
			conditions.municipio = data.municipality;
		}

		if (data.entidad_group.length) {
			conditions.entidad_group = data.entidad_group;
		}

		if (data.month) {
			//conditions.month = data.month;
		}

		if (data.year) {
			conditions.year = data.year;
		}

		if (data.passed) {
			conditions.fallecio = data.passed;
		}

		if (events) {
			let filteredEvents = events;

			if (data.fromdate && data.todate) {
				filteredEvents = filteredEvents.filter(event => {
					const eventDate = new Date(event.fecha_evento);
					const fromDate = new Date(data.fromdate);
					const toDate = new Date(data.todate);
					return eventDate >= fromDate && eventDate <= toDate;
				});
			} else if (data.fromdate) {
				filteredEvents = filteredEvents.filter(event => {
					const eventDate = new Date(event.fecha_evento);
					const fromDate = new Date(data.fromdate);
					return eventDate >= fromDate;
				});
			} else if (data.todate) {
				filteredEvents = filteredEvents.filter(event => {
					const eventDate = new Date(event.fecha_evento);
					const toDate = new Date(data.todate);
					return eventDate <= toDate;
				});
			}

			if (data.region) {
				filteredEvents = filteredEvents.filter(event =>
					event.region === data.region
				);
			}

			if (data.municipality.length) {
				filteredEvents = filteredEvents.filter(event =>
					data.municipality.includes(event.municipio)
				);
			}

			if (!data.entidad_group.length) {
				filteredEvents = filteredEvents.filter(event =>
					event.estado_duplicado !== 'Duplicado'
				);
			}

			if (data.entidad_group.length) {
				filteredEvents = filteredEvents.filter(event =>
					data.entidad_group.includes(event.entidad_group)
				);
			}

			if (data.year) {
				filteredEvents = filteredEvents.filter(event =>
					event.year === data.year
				);
			}

			if (data.passed) {
				filteredEvents = filteredEvents.filter(event =>
					event.fallecio === data.passed
				);
			}

			if (data.opiodes.length) {
				filteredEvents = filteredEvents.filter(event =>
					event.opiodes && event.opiodes.some(opiode =>
						data.opiodes.includes(opiode)
					)
				);
			}

			setData(prevState => ({
				...prevState,
				data: filteredEvents,
			}));
		}
	}, [
		events,
		data.region,
		data.municipality,
		data.year,
		data.month,
		data.entidad_group,
		data.passed,
		data.fromdate,
		data.todate,
		data.opiodes,
	]);

	return (
		<>
			<MainMenu attached />
			<Grid stretched celled stackable>
				<Grid.Row>
					<Grid.Column mobile={16} tablet={5} computer={2}>
						<div>
							<Header as="h3">Eventos</Header>
							<p className="txt-bold">
								Datos de eventos de posibles sobredosis por consumo de opiáceos
								y administración de naloxona
							</p>
							<p>Filtrar Datos</p>
							<Form size="mini">
								<Form.Group>
									<Form.Field
										name="dateFrom"
										label="Desde"
										placeholder="Seleccionar..."
										dateFormat="MM/DD/YYYY"
										value={data.fromdate}
										control={DateInput}
										clearable
										animation="none"
										pickerStyle={{ fontSize: '.78571429rem' }}
										hideMobileKeyboard
										onChange={fromDateChangeHandler}
									/>
								</Form.Group>
								<Form.Group>
									<Form.Field
										name="dateTo"
										label="Hasta"
										placeholder="Seleccionar..."
										dateFormat="MM/DD/YYYY"
										value={data.todate}
										control={DateInput}
										animation="none"
										clearable
										hideMobileKeyboard
										onChange={toDateChangeHandler}
									/>
								</Form.Group>
								<Form.Field
									name="regions"
									label="Regiones"
									placeholder="Seleccionar..."
									control={Dropdown}
									fluid
									search
									selection
									clearable
									value={data.region}
									onChange={(e, { value }) => {
										setData({ ...data, region: value });
									}}
									noResultsMessage="No hubo resultados"
									options={regions()}
								/>
								<Form.Group grouped>
									<Form.Field
										name="municipality"
										label="Municipios"
										placeholder="Seleccionar..."
										control={Dropdown}
										fluid
										search
										multiple
										selection
										clearable
										value={data.municipality || []}
										onChange={(e, { value }) => {
											setData({ ...data, municipality: [...value] });
										}}
										noResultsMessage="No hubo resultados"
										options={municipalities()}
									/>
								</Form.Group>
								<Form.Field
									name="passed"
									label="Fatalidad"
									placeholder="Seleccionar..."
									control={Dropdown}
									fluid
									search
									selection
									clearable
									value={data.passed}
									onChange={(e, { value }) => {
										setData({ ...data, passed: value });
									}}
									noResultsMessage="No hubo resultados"
									options={[
										{
											key: 'Sí',
											text: 'Sí',
											value: 'Sí',
										},
										{
											key: 'No',
											text: 'No',
											value: 'No',
										},
									]}
								/>
								<Form.Group grouped>
									<Form.Field
										name="place"
										label="Entidad"
										placeholder="Seleccionar..."
										control={Dropdown}
										fluid
										search
										selection
										multiple
										clearable
										value={data.entidad_group || []}
										onChange={(e, { value }) => {
											setData({ ...data, entidad_group: [...value] });
										}}
										noResultsMessage="No hubo resultados"
										options={
											events && events.length > 0
												? _.uniq(
													events
														.filter(event => event.entidad_group && event.entidad_group.trim() !== "")
														.map(event => event.entidad_group)
												)
													.sort((a, b) => a.localeCompare(b))
													.map((name, index) => ({
														key: `${name}-${index}`,
														text: name,
														value: name,
													}))
												: []
										}
									/>

								</Form.Group>
								<Form.Field
									name="year"
									label="Año"
									placeholder="Seleccionar..."
									control={Dropdown}
									fluid
									search
									selection
									clearable
									value={data.year}
									onChange={(e, { value }) => {
										setData({ ...data, year: value });
									}}
									noResultsMessage="No hubo resultados"
									options={_.map(
										_.filter(_.uniqBy(events, 'year'), (o) => {
											return o.year !== '';
										}),
										(item) => {
											return {
												key: item.year,
												text: item.year,
												value: item.year,
											};
										}
									)}
								/>
								<Form.Group grouped>
									<Form.Field
										name="opiodes"
										label="Opiodes"
										placeholder="Seleccionar..."
										control={Dropdown}
										fluid
										search
										selection
										clearable
										multiple
										value={data.opiodes || []}
										onChange={(e, { value }) => {
											setData({ ...data, opiodes: [...value] });
										}}
										noResultsMessage="No hubo resultados"
										options={opiodesValues.map((item) => {
											return {
												key: item,
												text: item,
												value: item,
											};
										})}
									/>
								</Form.Group>
							</Form>
						</div>
					</Grid.Column>
					<Grid.Column mobile={16} tablet={11} computer={14}>
						<Grid celled stackable>
							<Grid.Row columns={1}>
								<Grid.Column>
									<Map data={data.data} />
								</Grid.Column>
							</Grid.Row>
							<Grid.Row>
								<Grid.Column width={8} className="chart">
									<AgeChart data={data.data} />
								</Grid.Column>
								<Grid.Column width={4} className="chart">
									<SexChart data={data.data} />
								</Grid.Column>
								<Grid.Column width={4} className="chart">
									<SleepChart data={data.data} />
								</Grid.Column>
							</Grid.Row>
							<Grid.Row>
								<Grid.Column width={8} className="chart">
									<SubstancesChart data={data.data} />
								</Grid.Column>
								<Grid.Column width={8} className="chart">
									<ResultChart data={data.data} />
								</Grid.Column>
							</Grid.Row>
							<Grid.Row columns={4}>
								<Grid.Column className="chart">
									<PrescribeChart data={data.data} />
								</Grid.Column>
								<Grid.Column className="chart">
									<NaloxonaChart data={data.data} />
								</Grid.Column>
								<Grid.Column className="chart">
									<DoseChart data={data.data} />
								</Grid.Column>
								<Grid.Column className="chart">
									<PassedChart data={data.data} />
								</Grid.Column>
							</Grid.Row>
							<Grid.Row columns={2}>
								<Grid.Column className="chart">
									<TimelineChart data={data.data} />
								</Grid.Column>
								<Grid.Column className="chart">
									<PlaceChart data={data.data} />
								</Grid.Column>
							</Grid.Row>
							<Grid.Row columns={1}>
								<Grid.Column className="chart">
									<MonthlyChart data={data.data} />
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</>
	);
}

export default Dashboard;
